import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { deleteToken, getMessaging, getToken, onMessage } from "firebase/messaging";
import { StorageService } from './storage.service';
import { TabCommunicationService } from './tab-communication.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { RealtimeService } from './realtime.service';
import { NOTIFICATION_DEVICE_TOKEN } from '../enum/common-enum';
import { NotificationService } from '../components/header/elements/notification/notification.service';


@Injectable({
  providedIn: 'root'
})
export class PushNotificationService {

  constructor(private storageService: StorageService, 
              private tabCommunicationService: TabCommunicationService,
              private ngxService: NgxUiLoaderService, 
              private realtimeService: RealtimeService,
              private notificationService : NotificationService) { }
 private messaging ;
 private registration;
  requestPermission() {
    return new Promise((resolve) => {
        if (!("Notification" in window)) {
            console.log("Notifications are not supported in this browser.");
            resolve("denied");
        } 
        else {
            this.ngxService.start();
            Notification.requestPermission().then((permission) => {
                if (permission == "granted") {
                    const messaging = getMessaging();
                    this.messaging = getMessaging();
                    onMessage(this.messaging, (payload) => {
                      this.notificationService.triggerNotification.next(payload);
                      console.log(payload , "notificationPayload")
                      })
                    // Register the service worker before calling getToken
                    navigator.serviceWorker.ready.then(()=>{
                      console.log('serviceWorker Ready')
                    })
               
                  navigator.serviceWorker.register("/firebase-messaging-sw.js")
                  .then((registration) => {
                    let serviceWorker;
                
                    if (registration.installing) {
                      serviceWorker = registration.installing;
                      console.log('Service worker installing');
                    } else if (registration.waiting) {
                      serviceWorker = registration.waiting;
                      console.log('Service worker installed & waiting');
                    } else if (registration.active) {
                      serviceWorker = registration.active;
                      console.log('Service worker active');
                    }

                    this.registration = registration;
                
                    if (serviceWorker) {
                      console.log("sw current state", serviceWorker.state);
                      if (serviceWorker.state == "activated") {
                        //If push subscription wasn't done yet have to do here
                        console.log("sw already activated - Do whatever needed here");
                        // this.getTokenForsubscription();
                      }
                      serviceWorker.addEventListener("statechange", (e) => {
                        console.log("sw statechange: ", e.target.state);
                        if (e.target.state == "activated") {
                          console.log("Just now activated. Now we can subscribe for push notification");
                          // this.getTokenForsubscription();
                          this.ngxService.stop()
                        }
                      });
                    }
                    this.ngxService.stop()
  
                  })
                  .catch((err) => {
                    this.ngxService.stop();
                    console.error("Error registering the service worker: ", err);
                  }).finally(()=>{
                    
                  });
                }
                  else if (permission === 'denied') {
                    this.ngxService.stop();
                    alert('Notification permission required,Allow Notification from site settings');
                  // Do something when permission is denied.
                } else {
                    this.ngxService.stop();
                    alert('Notification permission required,Allow Notification from site settings');
                  // Do something when permission is dismissed or not available.
                }
            });
        }
    });
  }


  // getTokenForsubscription(){
  //   getToken(this.messaging, {
  //     vapidKey: environment.firebase.vapidKey,
  //     serviceWorkerRegistration: this.registration,
  //   }).then((currentToken:any) => {
  //     if (currentToken) {
  //       // Ensure correct reference to this.storageService
  //       this.storageService.currentDeviceToken.next(currentToken);
  //       this.storageService.store("notificationDeviceToken", currentToken);
  //       console.log(currentToken);
  //     } else {
  //       console.log("No registration token available. Request permission to generate one.");
  //     }
  //   }).catch((err) => {
  //     console.log("An error occurred while retrieving token: ", err);
  //   }).finally(()=> {
  //     this.ngxService.stop();
  //   });
  // }

  async getTokenForSubscription(): Promise<void> {
    try {
      const currentToken:any = await getToken(this.messaging, {
        vapidKey: environment.firebase.vapidKey,
        serviceWorkerRegistration: this.registration,
      });
  
      if (currentToken) {
        this.storageService.currentDeviceToken.next(currentToken);
        this.storageService.store(NOTIFICATION_DEVICE_TOKEN, currentToken);
        console.log(currentToken);
      } else {
        console.log("No registration token available. Request permission to generate one.");
      }
    } catch (err) {
      console.log("An error occurred while retrieving token: ", err);
    } finally {
      this.ngxService.stop();
    }
  }
  

  async deleteDeviceToken(): Promise<void> {
    try {
      const success = await deleteToken(this.messaging);
      if (success) {
        console.log('FCM Token deleted successfully');
      } else {
        console.log('FCM Token could not be deleted');
      }
    } catch (error) {
      console.error('Error deleting FCM token:', error);
    }
  }
}
